import { cva, type VariantProps } from "class-variance-authority";
import { type ForwardedRef, forwardRef, type ImgHTMLAttributes } from "react";

import LoadableImage from "common/components/ui/LoadableImage";

import FallbackCompanyImage from "assets/images/profile-placeholders/company.png";

const companyImageVariants = cva("object-cover", {
  variants: {
    size: {
      "3xs": "size-4 rounded",
      sm: "size-8 rounded-2xl",
      md: "rounded-2xl size-10",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type CompanyImageProps = ImgHTMLAttributes<HTMLImageElement> &
  VariantProps<typeof companyImageVariants> & {
    src: string;
  };

function CompanyImage(
  { size, className, ...rest }: CompanyImageProps,
  ref: ForwardedRef<HTMLImageElement>,
) {
  return (
    <LoadableImage
      ref={ref}
      className={companyImageVariants({ size, className })}
      fallbackImage={FallbackCompanyImage}
      {...rest}
    />
  );
}

const CompanyImageWithRef = forwardRef(CompanyImage);
CompanyImageWithRef.displayName = "CompanyImage";

export default CompanyImageWithRef;
